import * as React from 'react';
import { Entry } from 'contentful';

import styled, { tstyled } from '../../../theme';
import { IProjectContent } from '../../../models/Project';
import VideoOrImage from './VideoOrImage';

interface IProps {
  projectContent: Entry<IProjectContent>;
  containerWidth: number;
}

const Container = tstyled<{ containerWidth: number }>(styled.div)`
  > * {
    width: 100%;
  }

  @media (min-width: ${props => props.theme.mobileBreakpoint}px) {
    > * {
      height: ${props => props.containerWidth * 0.507}px;
    }
  }
`;

export default class OneOne extends React.PureComponent<IProps> {
  render() {
    return (
      <Container containerWidth={this.props.containerWidth}>
        <VideoOrImage projectContent={this.props.projectContent} />
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Project/ProjectContent/OneOne.tsx